import i18n from '@/i18n';
import { MetricSubType } from '@/proto/metric';

export const SUB_METRIC_OPTIONS = [
  { label: i18n.t('上报次数'), value: MetricSubType.SUB_TYPE_COUNT },
  { label: i18n.t('上报设备数'), value: MetricSubType.SUB_TYPE_DEVICE_UV },
  { label: i18n.t('上报用户数'), value: MetricSubType.SUB_TYPE_USER_UV },
];
export const DIMENSION_OPTIONS = [
  { label: i18n.t('APP版本'), value: 'app_version', color: '#60DBB4' },
  { label: i18n.t('系统版本'), value: 'os_version', color: '#3385FF' },
  { label: i18n.t('机型'), value: 'model', color: '#52B7FF' },

  { label: i18n.t('运营商'), value: 'operator', color: '#60DBB4' },
  { label: i18n.t('进程'), value: 'process_name', color: '#3385FF' },
  { label: 'Bundle ID', value: 'bundle_id', color: '#52B7FF' },
];

export const DIMENSION_NAMES = [
  { label: i18n.t('域名'), value: 'domain' },
  { label: 'URL', value: 'peer_name' },
  // { label: '场景', value: 'stage' },
  { label: i18n.t('网络库'), value: 'traffic_type' },
];
